import { JobTitle, JobTitlesListModel } from '@/modules/job-titles/types'
import { useAxiosModule } from '@/modules/_shared/axios'
const { postToApi, getFromApi, deleteInApi, patchToApi, mockAdapter, apiUrl } = useAxiosModule()

export type GetJobTitlesListResponse = JobTitlesListModel[]
const getJobTitlesListUrl = 'members/job-titles'

export async function getJobTitlesList () {
    return getFromApi<GetJobTitlesListResponse>(getJobTitlesListUrl)
}

export type GetJobTitleResponse = JobTitle
const getJobTitleUrl = 'jobtitle/get/'

mockAdapter.onGet(apiUrl(getJobTitleUrl + '1')).reply(200,
    {
        id: 1,
        value: 'HR-asiantuntija'
    }
)

export async function getSingleJobTitle (id: string) {
    return getFromApi<GetJobTitleResponse>(getJobTitleUrl + id)
}

export type AddJobTitleRequest = JobTitle

const addJobTitleUrl = 'jobtitle/add/'

mockAdapter.onPost(apiUrl(addJobTitleUrl)).reply(200, null)

export async function addSingleJobTitle (req: AddJobTitleRequest) {
    return postToApi<null>(addJobTitleUrl, req)
}

export type UpdateJobTitleRequest = JobTitle

const updateJobTitleUrl = 'jobtitle/update/'

mockAdapter.onPost(apiUrl(updateJobTitleUrl + '1')).reply(200, null)

export async function updateSingleJobTitle (id: string, req: UpdateJobTitleRequest) {
    return patchToApi<null>(updateJobTitleUrl + id, req)
}

const deleteJobTitleUrl = 'jobtitle/delete/'

mockAdapter.onDelete(apiUrl(deleteJobTitleUrl + '1')).reply(200, null)

export async function deleteSingleJobTitle (id: string) {
    return deleteInApi<null>(deleteJobTitleUrl + id)
}
